@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_455_372_038)
internal val Res.string.album_generated_name_netease: StringResource by lazy {
      StringResource("string:album_generated_name_netease", "album_generated_name_netease", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9153, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10401, 64),
      ))
    }

@delegate:ResourceContentHash(-1_761_140_317)
internal val Res.string.album_generated_name_qq: StringResource by lazy {
      StringResource("string:album_generated_name_qq", "album_generated_name_qq", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9278, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10530, 51),
      ))
    }

@delegate:ResourceContentHash(874_382_711)
internal val Res.string.album_generated_name_qq_default: StringResource by lazy {
      StringResource("string:album_generated_name_qq_default", "album_generated_name_qq_default", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9218, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10466, 63),
      ))
    }

@delegate:ResourceContentHash(1_386_822_673)
internal val Res.string.album_links_tips_1: StringResource by lazy {
      StringResource("string:album_links_tips_1", "album_links_tips_1", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9330, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10582, 86),
      ))
    }

@delegate:ResourceContentHash(19_923_481)
internal val Res.string.album_links_tips_2: StringResource by lazy {
      StringResource("string:album_links_tips_2", "album_links_tips_2", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9421, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10669, 70),
      ))
    }

@delegate:ResourceContentHash(-1_110_415_764)
internal val Res.string.album_links_tips_title: StringResource by lazy {
      StringResource("string:album_links_tips_title", "album_links_tips_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9500, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10740, 74),
      ))
    }

@delegate:ResourceContentHash(-1_777_745_888)
internal val Res.string.album_platform_apple: StringResource by lazy {
      StringResource("string:album_platform_apple", "album_platform_apple", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9567, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10815, 44),
      ))
    }

@delegate:ResourceContentHash(951_382_592)
internal val Res.string.album_platform_line_apple: StringResource by lazy {
      StringResource("string:album_platform_line_apple", "album_platform_line_apple", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9612, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10860, 77),
      ))
    }

@delegate:ResourceContentHash(-1_150_836_352)
internal val Res.string.album_platform_line_netease: StringResource by lazy {
      StringResource("string:album_platform_line_netease", "album_platform_line_netease", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9690, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10938, 87),
      ))
    }

@delegate:ResourceContentHash(-1_918_048_149)
internal val Res.string.album_platform_line_qq: StringResource by lazy {
      StringResource("string:album_platform_line_qq", "album_platform_line_qq", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9774, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11026, 62),
      ))
    }

@delegate:ResourceContentHash(-21_324_393)
internal val Res.string.album_platform_netease: StringResource by lazy {
      StringResource("string:album_platform_netease", "album_platform_netease", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9837, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11089, 58),
      ))
    }

@delegate:ResourceContentHash(-1_000_401_117)
internal val Res.string.album_platform_qq: StringResource by lazy {
      StringResource("string:album_platform_qq", "album_platform_qq", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9888, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11148, 37),
      ))
    }

@delegate:ResourceContentHash(837_800_902)
internal val Res.string.album_playlist_example: StringResource by lazy {
      StringResource("string:album_playlist_example", "album_playlist_example", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9926, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11186, 50),
      ))
    }

@delegate:ResourceContentHash(-1_061_414_468)
internal val Res.string.anonymous_usage: StringResource by lazy {
      StringResource("string:anonymous_usage", "anonymous_usage", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9999, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11259, 55),
      ))
    }

@delegate:ResourceContentHash(1_780_886_291)
internal val Res.string.app_link_copied: StringResource by lazy {
      StringResource("string:app_link_copied", "app_link_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/app_sharing.commonMain.cvr", 10, 103),
        ResourceItem(setOf(), "${MD}values/app_sharing.commonMain.cvr", 10, 95),
      ))
    }

@delegate:ResourceContentHash(-1_409_917_206)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11315, 28),
      ))
    }

@delegate:ResourceContentHash(-684_782_276)
internal val Res.string.app_update_failed: StringResource by lazy {
      StringResource("string:app_update_failed", "app_update_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10059, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11344, 77),
      ))
    }

@delegate:ResourceContentHash(188_939_993)
internal val Res.string.are_you_clear_cache: StringResource by lazy {
      StringResource("string:are_you_clear_cache", "are_you_clear_cache", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10101, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11422, 71),
      ))
    }

@delegate:ResourceContentHash(-1_884_622_382)
internal val Res.string.auth_type: StringResource by lazy {
      StringResource("string:auth_type", "auth_type", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10258, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11587, 45),
      ))
    }

@delegate:ResourceContentHash(786_750_792)
internal val Res.string.auth_type_apikey: StringResource by lazy {
      StringResource("string:auth_type_apikey", "auth_type_apikey", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10165, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11494, 36),
      ))
    }

@delegate:ResourceContentHash(-188_737_098)
internal val Res.string.auth_type_user_and_pass: StringResource by lazy {
      StringResource("string:auth_type_user_and_pass", "auth_type_user_and_pass", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10202, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11531, 55),
      ))
    }

@delegate:ResourceContentHash(1_490_063_864)
internal val Res.string.auto_open_latest_source: StringResource by lazy {
      StringResource("string:auto_open_latest_source", "auto_open_latest_source", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10292, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11633, 63),
      ))
    }

@delegate:ResourceContentHash(137_450_220)
internal val Res.string.auto_play: StringResource by lazy {
      StringResource("string:auto_play", "auto_play", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10426, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11755, 41),
      ))
    }

@delegate:ResourceContentHash(2_135_668_300)
internal val Res.string.auto_play_full_screen: StringResource by lazy {
      StringResource("string:auto_play_full_screen", "auto_play_full_screen", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10364, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11697, 57),
      ))
    }

@delegate:ResourceContentHash(-1_128_344_488)
internal val Res.string.auto_refresh_source_content: StringResource by lazy {
      StringResource("string:auto_refresh_source_content", "auto_refresh_source_content", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10460, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11797, 71),
      ))
    }

@delegate:ResourceContentHash(856_433_908)
internal val Res.string.auto_update: StringResource by lazy {
      StringResource("string:auto_update", "auto_update", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10524, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11869, 43),
      ))
    }

@delegate:ResourceContentHash(1_976_789_537)
internal val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10568, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11942, 20),
      ))
    }

@delegate:ResourceContentHash(-649_454_588)
internal val Res.string.backward: StringResource by lazy {
      StringResource("string:backward", "backward", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11913, 28),
      ))
    }

@delegate:ResourceContentHash(-378_535_822)
internal val Res.string.boot_launch_may_not_work: StringResource by lazy {
      StringResource("string:boot_launch_may_not_work", "boot_launch_may_not_work", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10589, 132),
      ))
    }

@delegate:ResourceContentHash(1_992_424_423)
internal val Res.string.boot_launcher: StringResource by lazy {
      StringResource("string:boot_launcher", "boot_launcher", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10722, 37),
      ))
    }

@delegate:ResourceContentHash(-1_088_616_877)
internal val Res.string.branch_name_is_invalid: StringResource by lazy {
      StringResource("string:branch_name_is_invalid", "branch_name_is_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10760, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11963, 62),
      ))
    }

@delegate:ResourceContentHash(-1_165_171_790)
internal val Res.string.branche_name: StringResource by lazy {
      StringResource("string:branche_name", "branche_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10815, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12026, 36),
      ))
    }

@delegate:ResourceContentHash(-507_690_378)
internal val Res.string.button_back: StringResource by lazy {
      StringResource("string:button_back", "button_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12063, 27),
      ))
    }

@delegate:ResourceContentHash(-1_483_040_452)
internal val Res.string.cache_size: StringResource by lazy {
      StringResource("string:cache_size", "cache_size", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10852, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12091, 34),
      ))
    }

@delegate:ResourceContentHash(-84_326_927)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10887, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12126, 22),
      ))
    }

@delegate:ResourceContentHash(-105_520_899)
internal val Res.string.carousel: StringResource by lazy {
      StringResource("string:carousel", "carousel", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10942, 24),
      ))
    }

@delegate:ResourceContentHash(-1_996_024_785)
internal val Res.string.carousel_effect: StringResource by lazy {
      StringResource("string:carousel_effect", "carousel_effect", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10910, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12149, 35),
      ))
    }

@delegate:ResourceContentHash(-990_435_550)
internal val Res.string.check_for_update: StringResource by lazy {
      StringResource("string:check_for_update", "check_for_update", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10967, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12185, 48),
      ))
    }

@delegate:ResourceContentHash(935_620_494)
internal val Res.string.choose_collection: StringResource by lazy {
      StringResource("string:choose_collection", "choose_collection", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11008, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12234, 49),
      ))
    }

@delegate:ResourceContentHash(-1_086_841_287)
internal val Res.string.choose_folder: StringResource by lazy {
      StringResource("string:choose_folder", "choose_folder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12284, 41),
      ))
    }

@delegate:ResourceContentHash(6_325_299)
internal val Res.string.choose_image_type: StringResource by lazy {
      StringResource("string:choose_image_type", "choose_image_type", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11050, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12326, 49),
      ))
    }

@delegate:ResourceContentHash(-1_501_355_648)
internal val Res.string.choose_language: StringResource by lazy {
      StringResource("string:choose_language", "choose_language", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11100, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12376, 43),
      ))
    }

@delegate:ResourceContentHash(789_911_063)
internal val Res.string.choose_music_platform: StringResource by lazy {
      StringResource("string:choose_music_platform", "choose_music_platform", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11140, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12420, 57),
      ))
    }

@delegate:ResourceContentHash(-305_143_517)
internal val Res.string.choose_region: StringResource by lazy {
      StringResource("string:choose_region", "choose_region", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11194, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12478, 41),
      ))
    }

@delegate:ResourceContentHash(914_709_760)
internal val Res.string.choose_type: StringResource by lazy {
      StringResource("string:choose_type", "choose_type", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11232, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12520, 35),
      ))
    }

@delegate:ResourceContentHash(-1_548_925_028)
internal val Res.string.close: StringResource by lazy {
      StringResource("string:close", "close", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11268, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12556, 21),
      ))
    }

@delegate:ResourceContentHash(-932_810_936)
internal val Res.string.cloud_sync_account_changed_hint: StringResource by lazy {
      StringResource("string:cloud_sync_account_changed_hint", "cloud_sync_account_changed_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 10, 235),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 10, 227),
      ))
    }

@delegate:ResourceContentHash(1_424_986_929)
internal val Res.string.cloud_sync_close: StringResource by lazy {
      StringResource("string:cloud_sync_close", "cloud_sync_close", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 246, 40),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 238, 32),
      ))
    }

@delegate:ResourceContentHash(-2_109_931_007)
internal val Res.string.cloud_sync_credentials_notice: StringResource by lazy {
      StringResource("string:cloud_sync_credentials_notice", "cloud_sync_credentials_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 287, 249),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 271, 269),
      ))
    }

@delegate:ResourceContentHash(-1_398_958_170)
internal val Res.string.cloud_sync_delete_cloud_data: StringResource by lazy {
      StringResource("string:cloud_sync_delete_cloud_data", "cloud_sync_delete_cloud_data", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 751, 76),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 747, 80),
      ))
    }

@delegate:ResourceContentHash(-1_257_715_042)
internal val Res.string.cloud_sync_delete_cloud_data_hint: StringResource by lazy {
      StringResource("string:cloud_sync_delete_cloud_data_hint", "cloud_sync_delete_cloud_data_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 537, 213),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 541, 205),
      ))
    }

@delegate:ResourceContentHash(968_268_405)
internal val Res.string.cloud_sync_description: StringResource by lazy {
      StringResource("string:cloud_sync_description", "cloud_sync_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 828, 278),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 828, 302),
      ))
    }

@delegate:ResourceContentHash(601_612_647)
internal val Res.string.cloud_sync_disable: StringResource by lazy {
      StringResource("string:cloud_sync_disable", "cloud_sync_disable", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1107, 34),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1131, 38),
      ))
    }

@delegate:ResourceContentHash(1_879_771_810)
internal val Res.string.cloud_sync_enable: StringResource by lazy {
      StringResource("string:cloud_sync_enable", "cloud_sync_enable", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1142, 33),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1170, 37),
      ))
    }

@delegate:ResourceContentHash(667_307_478)
internal val Res.string.cloud_sync_now: StringResource by lazy {
      StringResource("string:cloud_sync_now", "cloud_sync_now", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1176, 38),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1208, 34),
      ))
    }

@delegate:ResourceContentHash(-738_280_681)
internal val Res.string.cloud_sync_status_account_changed: StringResource by lazy {
      StringResource("string:cloud_sync_status_account_changed", "cloud_sync_status_account_changed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1215, 89),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1243, 81),
      ))
    }

@delegate:ResourceContentHash(2_057_377_435)
internal val Res.string.cloud_sync_status_failed: StringResource by lazy {
      StringResource("string:cloud_sync_status_failed", "cloud_sync_status_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1305, 48),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1325, 48),
      ))
    }

@delegate:ResourceContentHash(1_938_840_433)
internal val Res.string.cloud_sync_status_needs_upgrade: StringResource by lazy {
      StringResource("string:cloud_sync_status_needs_upgrade", "cloud_sync_status_needs_upgrade", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1354, 79),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1374, 79),
      ))
    }

@delegate:ResourceContentHash(624_817_782)
internal val Res.string.cloud_sync_status_off: StringResource by lazy {
      StringResource("string:cloud_sync_status_off", "cloud_sync_status_off", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1434, 41),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1454, 33),
      ))
    }

@delegate:ResourceContentHash(-292_820_731)
internal val Res.string.cloud_sync_status_quota: StringResource by lazy {
      StringResource("string:cloud_sync_status_quota", "cloud_sync_status_quota", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1476, 75),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1488, 71),
      ))
    }

@delegate:ResourceContentHash(1_318_622_027)
internal val Res.string.cloud_sync_status_synced: StringResource by lazy {
      StringResource("string:cloud_sync_status_synced", "cloud_sync_status_synced", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1552, 48),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1560, 48),
      ))
    }

@delegate:ResourceContentHash(-1_922_667_346)
internal val Res.string.cloud_sync_status_syncing: StringResource by lazy {
      StringResource("string:cloud_sync_status_syncing", "cloud_sync_status_syncing", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1601, 53),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1609, 49),
      ))
    }

@delegate:ResourceContentHash(360_970_469)
internal val Res.string.cloud_sync_status_unavailable: StringResource by lazy {
      StringResource("string:cloud_sync_status_unavailable", "cloud_sync_status_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1655, 61),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1659, 61),
      ))
    }

@delegate:ResourceContentHash(425_522_288)
internal val Res.string.cloud_sync_status_waiting: StringResource by lazy {
      StringResource("string:cloud_sync_status_waiting", "cloud_sync_status_waiting", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1717, 61),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1721, 57),
      ))
    }

@delegate:ResourceContentHash(685_483_846)
internal val Res.string.cloud_sync_title: StringResource by lazy {
      StringResource("string:cloud_sync_title", "cloud_sync_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1779, 44),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1779, 40),
      ))
    }

@delegate:ResourceContentHash(414_314_780)
internal val Res.string.cloud_sync_unavailable_hint: StringResource by lazy {
      StringResource("string:cloud_sync_unavailable_hint", "cloud_sync_unavailable_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/cloud_sync.commonMain.cvr", 1824, 187),
        ResourceItem(setOf(), "${MD}values/cloud_sync.commonMain.cvr", 1820, 227),
      ))
    }

@delegate:ResourceContentHash(-40_835_113)
internal val Res.string.collection_id: StringResource by lazy {
      StringResource("string:collection_id", "collection_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12578, 41),
      ))
    }

@delegate:ResourceContentHash(-1_642_907_329)
internal val Res.string.column: StringResource by lazy {
      StringResource("string:column", "column", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11290, 18),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12620, 22),
      ))
    }

@delegate:ResourceContentHash(90_124_020)
internal val Res.string.coming_soon: StringResource by lazy {
      StringResource("string:coming_soon", "coming_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11309, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12643, 35),
      ))
    }

@delegate:ResourceContentHash(-2_011_417_869)
internal val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11401, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12751, 27),
      ))
    }

@delegate:ResourceContentHash(897_693_411)
internal val Res.string.confirm_delete_text: StringResource by lazy {
      StringResource("string:confirm_delete_text", "confirm_delete_text", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11349, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12679, 71),
      ))
    }

@delegate:ResourceContentHash(949_269_097)
internal val Res.string.connection_failed: StringResource by lazy {
      StringResource("string:connection_failed", "connection_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11425, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12779, 49),
      ))
    }

@delegate:ResourceContentHash(205_545_169)
internal val Res.string.connection_successful: StringResource by lazy {
      StringResource("string:connection_successful", "connection_successful", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11467, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12829, 57),
      ))
    }

@delegate:ResourceContentHash(-1_204_535_448)
internal val Res.string.connection_tiemout: StringResource by lazy {
      StringResource("string:connection_tiemout", "connection_tiemout", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11513, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12887, 50),
      ))
    }

@delegate:ResourceContentHash(-940_676_355)
internal val Res.string.contain_video: StringResource by lazy {
      StringResource("string:contain_video", "contain_video", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11564, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12938, 41),
      ))
    }

@delegate:ResourceContentHash(556_148_268)
internal val Res.string.cube_effect: StringResource by lazy {
      StringResource("string:cube_effect", "cube_effect", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11602, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12980, 27),
      ))
    }

@delegate:ResourceContentHash(-948_207_746)
internal val Res.string.current_version: StringResource by lazy {
      StringResource("string:current_version", "current_version", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11634, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13008, 43),
      ))
    }

@delegate:ResourceContentHash(694_516_091)
internal val Res.string.dark_mode: StringResource by lazy {
      StringResource("string:dark_mode", "dark_mode", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11674, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13052, 33),
      ))
    }

@delegate:ResourceContentHash(2_001_245_335)
internal val Res.string.data_not_found: StringResource by lazy {
      StringResource("string:data_not_found", "data_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11708, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13086, 42),
      ))
    }

@delegate:ResourceContentHash(1_450_322_956)
internal val Res.string.data_under_construct: StringResource by lazy {
      StringResource("string:data_under_construct", "data_under_construct", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13129, 60),
      ))
    }

@delegate:ResourceContentHash(-352_045_418)
internal val Res.string.default_branch: StringResource by lazy {
      StringResource("string:default_branch", "default_branch", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11751, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13190, 42),
      ))
    }

@delegate:ResourceContentHash(-1_398_051_573)
internal val Res.string.default_effect: StringResource by lazy {
      StringResource("string:default_effect", "default_effect", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11790, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13233, 34),
      ))
    }

@delegate:ResourceContentHash(-1_073_549_306)
internal val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11821, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13268, 22),
      ))
    }

@delegate:ResourceContentHash(492_503_666)
internal val Res.string.device_brand: StringResource by lazy {
      StringResource("string:device_brand", "device_brand", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13291, 28),
      ))
    }

@delegate:ResourceContentHash(2_004_035_896)
internal val Res.string.device_model: StringResource by lazy {
      StringResource("string:device_model", "device_model", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13320, 28),
      ))
    }

@delegate:ResourceContentHash(-36_529_509)
internal val Res.string.device_version: StringResource by lazy {
      StringResource("string:device_version", "device_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13349, 42),
      ))
    }

@delegate:ResourceContentHash(-1_381_766_143)
internal val Res.string.display_mode: StringResource by lazy {
      StringResource("string:display_mode", "display_mode", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11955, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13511, 36),
      ))
    }

@delegate:ResourceContentHash(1_766_959_192)
internal val Res.string.display_mode_center: StringResource by lazy {
      StringResource("string:display_mode_center", "display_mode_center", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11844, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13392, 35),
      ))
    }

@delegate:ResourceContentHash(406_606_013)
internal val Res.string.display_mode_full: StringResource by lazy {
      StringResource("string:display_mode_full", "display_mode_full", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11921, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13477, 33),
      ))
    }

@delegate:ResourceContentHash(629_395_842)
internal val Res.string.display_mode_full_screen: StringResource by lazy {
      StringResource("string:display_mode_full_screen", "display_mode_full_screen", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11880, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13428, 48),
      ))
    }

@delegate:ResourceContentHash(-1_749_523_186)
internal val Res.string.display_orientation_horizontal: StringResource by lazy {
      StringResource("string:display_orientation_horizontal", "display_orientation_horizontal", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 11992, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13548, 54),
      ))
    }

@delegate:ResourceContentHash(-211_048_910)
internal val Res.string.display_orientation_vertical: StringResource by lazy {
      StringResource("string:display_orientation_vertical", "display_orientation_vertical", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12039, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13603, 48),
      ))
    }

@delegate:ResourceContentHash(-1_261_508_512)
internal val Res.string.display_style_bento: StringResource by lazy {
      StringResource("string:display_style_bento", "display_style_bento", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12084, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13652, 35),
      ))
    }

@delegate:ResourceContentHash(-1_319_053_037)
internal val Res.string.display_style_calender: StringResource by lazy {
      StringResource("string:display_style_calender", "display_style_calender", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12120, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13688, 50),
      ))
    }

@delegate:ResourceContentHash(1_439_761_964)
internal val Res.string.display_style_carousel: StringResource by lazy {
      StringResource("string:display_style_carousel", "display_style_carousel", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12167, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13739, 42),
      ))
    }

@delegate:ResourceContentHash(556_148_268)
internal val Res.string.display_style_cube: StringResource by lazy {
      StringResource("string:display_style_cube", "display_style_cube", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12214, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13782, 34),
      ))
    }

@delegate:ResourceContentHash(-471_999_255)
internal val Res.string.display_style_fade: StringResource by lazy {
      StringResource("string:display_style_fade", "display_style_fade", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12253, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13817, 34),
      ))
    }

@delegate:ResourceContentHash(-1_120_673_493)
internal val Res.string.display_style_frame_wall: StringResource by lazy {
      StringResource("string:display_style_frame_wall", "display_style_frame_wall", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12296, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13852, 48),
      ))
    }

@delegate:ResourceContentHash(31_910_391)
internal val Res.string.display_style_reveal: StringResource by lazy {
      StringResource("string:display_style_reveal", "display_style_reveal", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12341, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13901, 36),
      ))
    }

@delegate:ResourceContentHash(1_451_344_046)
internal val Res.string.display_style_slide: StringResource by lazy {
      StringResource("string:display_style_slide", "display_style_slide", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 12378, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13938, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("album_generated_name_netease", Res.string.album_generated_name_netease)
  map.put("album_generated_name_qq", Res.string.album_generated_name_qq)
  map.put("album_generated_name_qq_default", Res.string.album_generated_name_qq_default)
  map.put("album_links_tips_1", Res.string.album_links_tips_1)
  map.put("album_links_tips_2", Res.string.album_links_tips_2)
  map.put("album_links_tips_title", Res.string.album_links_tips_title)
  map.put("album_platform_apple", Res.string.album_platform_apple)
  map.put("album_platform_line_apple", Res.string.album_platform_line_apple)
  map.put("album_platform_line_netease", Res.string.album_platform_line_netease)
  map.put("album_platform_line_qq", Res.string.album_platform_line_qq)
  map.put("album_platform_netease", Res.string.album_platform_netease)
  map.put("album_platform_qq", Res.string.album_platform_qq)
  map.put("album_playlist_example", Res.string.album_playlist_example)
  map.put("anonymous_usage", Res.string.anonymous_usage)
  map.put("app_link_copied", Res.string.app_link_copied)
  map.put("app_name", Res.string.app_name)
  map.put("app_update_failed", Res.string.app_update_failed)
  map.put("are_you_clear_cache", Res.string.are_you_clear_cache)
  map.put("auth_type", Res.string.auth_type)
  map.put("auth_type_apikey", Res.string.auth_type_apikey)
  map.put("auth_type_user_and_pass", Res.string.auth_type_user_and_pass)
  map.put("auto_open_latest_source", Res.string.auto_open_latest_source)
  map.put("auto_play", Res.string.auto_play)
  map.put("auto_play_full_screen", Res.string.auto_play_full_screen)
  map.put("auto_refresh_source_content", Res.string.auto_refresh_source_content)
  map.put("auto_update", Res.string.auto_update)
  map.put("back", Res.string.back)
  map.put("backward", Res.string.backward)
  map.put("boot_launch_may_not_work", Res.string.boot_launch_may_not_work)
  map.put("boot_launcher", Res.string.boot_launcher)
  map.put("branch_name_is_invalid", Res.string.branch_name_is_invalid)
  map.put("branche_name", Res.string.branche_name)
  map.put("button_back", Res.string.button_back)
  map.put("cache_size", Res.string.cache_size)
  map.put("cancel", Res.string.cancel)
  map.put("carousel", Res.string.carousel)
  map.put("carousel_effect", Res.string.carousel_effect)
  map.put("check_for_update", Res.string.check_for_update)
  map.put("choose_collection", Res.string.choose_collection)
  map.put("choose_folder", Res.string.choose_folder)
  map.put("choose_image_type", Res.string.choose_image_type)
  map.put("choose_language", Res.string.choose_language)
  map.put("choose_music_platform", Res.string.choose_music_platform)
  map.put("choose_region", Res.string.choose_region)
  map.put("choose_type", Res.string.choose_type)
  map.put("close", Res.string.close)
  map.put("cloud_sync_account_changed_hint", Res.string.cloud_sync_account_changed_hint)
  map.put("cloud_sync_close", Res.string.cloud_sync_close)
  map.put("cloud_sync_credentials_notice", Res.string.cloud_sync_credentials_notice)
  map.put("cloud_sync_delete_cloud_data", Res.string.cloud_sync_delete_cloud_data)
  map.put("cloud_sync_delete_cloud_data_hint", Res.string.cloud_sync_delete_cloud_data_hint)
  map.put("cloud_sync_description", Res.string.cloud_sync_description)
  map.put("cloud_sync_disable", Res.string.cloud_sync_disable)
  map.put("cloud_sync_enable", Res.string.cloud_sync_enable)
  map.put("cloud_sync_now", Res.string.cloud_sync_now)
  map.put("cloud_sync_status_account_changed", Res.string.cloud_sync_status_account_changed)
  map.put("cloud_sync_status_failed", Res.string.cloud_sync_status_failed)
  map.put("cloud_sync_status_needs_upgrade", Res.string.cloud_sync_status_needs_upgrade)
  map.put("cloud_sync_status_off", Res.string.cloud_sync_status_off)
  map.put("cloud_sync_status_quota", Res.string.cloud_sync_status_quota)
  map.put("cloud_sync_status_synced", Res.string.cloud_sync_status_synced)
  map.put("cloud_sync_status_syncing", Res.string.cloud_sync_status_syncing)
  map.put("cloud_sync_status_unavailable", Res.string.cloud_sync_status_unavailable)
  map.put("cloud_sync_status_waiting", Res.string.cloud_sync_status_waiting)
  map.put("cloud_sync_title", Res.string.cloud_sync_title)
  map.put("cloud_sync_unavailable_hint", Res.string.cloud_sync_unavailable_hint)
  map.put("collection_id", Res.string.collection_id)
  map.put("column", Res.string.column)
  map.put("coming_soon", Res.string.coming_soon)
  map.put("confirm", Res.string.confirm)
  map.put("confirm_delete_text", Res.string.confirm_delete_text)
  map.put("connection_failed", Res.string.connection_failed)
  map.put("connection_successful", Res.string.connection_successful)
  map.put("connection_tiemout", Res.string.connection_tiemout)
  map.put("contain_video", Res.string.contain_video)
  map.put("cube_effect", Res.string.cube_effect)
  map.put("current_version", Res.string.current_version)
  map.put("dark_mode", Res.string.dark_mode)
  map.put("data_not_found", Res.string.data_not_found)
  map.put("data_under_construct", Res.string.data_under_construct)
  map.put("default_branch", Res.string.default_branch)
  map.put("default_effect", Res.string.default_effect)
  map.put("delete", Res.string.delete)
  map.put("device_brand", Res.string.device_brand)
  map.put("device_model", Res.string.device_model)
  map.put("device_version", Res.string.device_version)
  map.put("display_mode", Res.string.display_mode)
  map.put("display_mode_center", Res.string.display_mode_center)
  map.put("display_mode_full", Res.string.display_mode_full)
  map.put("display_mode_full_screen", Res.string.display_mode_full_screen)
  map.put("display_orientation_horizontal", Res.string.display_orientation_horizontal)
  map.put("display_orientation_vertical", Res.string.display_orientation_vertical)
  map.put("display_style_bento", Res.string.display_style_bento)
  map.put("display_style_calender", Res.string.display_style_calender)
  map.put("display_style_carousel", Res.string.display_style_carousel)
  map.put("display_style_cube", Res.string.display_style_cube)
  map.put("display_style_fade", Res.string.display_style_fade)
  map.put("display_style_frame_wall", Res.string.display_style_frame_wall)
  map.put("display_style_reveal", Res.string.display_style_reveal)
  map.put("display_style_slide", Res.string.display_style_slide)
}
